module.exports = __webpack_public_path__ + "static/img/reviews_user2.ca4eaaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/reviews_user2.png
// module id = 220
// module chunks = 1